<div class="granted-access-panel">
  <div class="granted-access-panel__tabs-header" role="tablist" aria-label="Granted access type">
    <button
      *ngFor="let tab of subTabs"
      type="button"
      class="granted-access-panel__tab-button"
      [class.active]="activeSubTab === tab.value"
      [attr.aria-selected]="activeSubTab === tab.value"
      (click)="setActiveSubTab(tab.value)"
    >
      {{ tab.label }}
    </button>
  </div>

  <div class="granted-access-panel__content-wrapper">
    <div class="granted-access-panel__content">
      <app-created-policies
        [policyPortal]="policyPortal"
        policyListType="owned"
        [policyTypes]="activePolicyTypes"
        [conversationRoute]="conversationRoute"
        [showToolbarAddPolicyButton]="false"
      ></app-created-policies>
    </div>
  </div>
</div>
